import Vue from 'vue'
import format from 'date-fns/format'
import isValid from 'date-fns/isValid'
import parseISO from 'date-fns/parseISO'
import isDate from 'date-fns/isDate'

Vue.filter('twoDecimalPlaces', (value) => {
  if (typeof value !== 'number') {
    return 0
  }
  return value.toFixed(2)
})

const commonDateFormat = 'yyyy-MM-dd'

Vue.filter('formatDate', (dateOrDateString) => {
  const date = isDate(dateOrDateString) ? dateOrDateString : parseISO(dateOrDateString)
  if (!isValid(date)) {
    return ''
  }
  return format(date, commonDateFormat)
})
